import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { cloneDeep } from 'lodash';
import useContentfulPromotionContent from 'hooks/useContentfulPromotionContent';
import SanitizedHtml from 'components/consumer/SanitizedHtml';
import desktopStaticNavItems from './desktopStaticNavItems';
const useDesktopNavItems = () => {
  const $ = _c(5);
  const {
    promotionData
  } = useContentfulPromotionContent();
  promotionData?.displayFlashSale;
  promotionData?.saleDropdownAuxPromoText;
  promotionData?.saleDropdownAuxPromoUrl;
  promotionData?.saleDropdownMedia;
  let updatedItems;
  if ($[0] !== promotionData?.displayFlashSale || $[1] !== promotionData?.saleDropdownAuxPromoText || $[2] !== promotionData?.saleDropdownAuxPromoUrl || $[3] !== promotionData?.saleDropdownMedia) {
    updatedItems = cloneDeep(desktopStaticNavItems);
    const joybirdDesignHouseGroup = updatedItems.find(_temp);
    const freeDesignServicesItem = joybirdDesignHouseGroup ? joybirdDesignHouseGroup.items.find(_temp2) : null;
    if (freeDesignServicesItem) {
      freeDesignServicesItem.label = "Free Design Services";
    }
    const saleCategory = updatedItems.find(_temp3);
    if (saleCategory) {
      saleCategory.image = promotionData?.saleDropdownMedia || saleCategory.image;
    }
    if (promotionData?.displayFlashSale) {
      saleCategory.items = [...saleCategory.items, {
        label: "Flash Sale",
        id: "flash-sale",
        url: "/flash-sale/"
      }];
    }
    if (promotionData?.saleDropdownAuxPromoText && promotionData?.saleDropdownAuxPromoUrl) {
      saleCategory.items = [{
        label: <SanitizedHtml as="span" html={promotionData?.saleDropdownAuxPromoText} />,
        id: "aux-promo-link",
        url: `${promotionData?.saleDropdownAuxPromoUrl}`
      }, ...saleCategory.items];
    }
    $[0] = promotionData?.displayFlashSale;
    $[1] = promotionData?.saleDropdownAuxPromoText;
    $[2] = promotionData?.saleDropdownAuxPromoUrl;
    $[3] = promotionData?.saleDropdownMedia;
    $[4] = updatedItems;
  } else {
    updatedItems = $[4];
  }
  const categoryNavItems = updatedItems;
  return categoryNavItems;
};
export default useDesktopNavItems;
function _temp(item) {
  return item.id === "joybird-design-house";
}
function _temp2(item_0) {
  return item_0.id === "free-design-services";
}
function _temp3(t0) {
  const {
    id
  } = t0;
  return id === "sale";
}